export interface Props {
	/**
	 * @title ID do Grupo de Produto
	 * @description Informe o productGroupID do produto para o Tolstoy Carousel
	 */
	productGroupID?: string
	publishId?: string
}

function TolstoySpotlightCarousel({ productGroupID, publishId }: Props) {
	return (
		<div
			class='my-6 w-full container px-4 lg:px-0'
			dangerouslySetInnerHTML={{
				__html: `
           <tolstoy-carousel class="tolstoy-carousel"
              id=${publishId}
            </tolstoy-carousel>
        `,
			}}
		/>
	)
}

export default TolstoySpotlightCarousel
